import React, { Fragment, useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  Form,
  Row,
  Col,
  Card,
  Button,
  CardBody,
} from "react-bootstrap";
import Cookies from "js-cookie";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";

import { loadSanadBranding } from "../utils/loadSanadBranding";
import SanadOmanVisaForm from "./SanadOmanVisaForm";
import SanadOmanVisaSummary from "./SanadOmanVisaSummary";

const { config } = require("../../api/api");

function SanadOmanVisaMain() {
  const [isHidePage, setIsHidePage] = useState("");
  const [sanadDetails, setSanadDetails] = useState(null);
  const [activeTab, setActiveTab] = useState("form");

  const [files, setFiles] = useState({
    passportCopy: null,
    photo1: null,
    photo2: null,
    supportingDocs: null,
  });

  const [formData,setFormData]=useState({
      fullName: "",
      nationality: "",
      nationalityId: "",
      dateOfBirth: "",
      gender: "",
      passportNumber: "",
      passportIssueDate: "",
      passportExpiryDate: "",
      countryOfIssue: "",
      countryOfIssueId: "",
      placeOfIssue: "",
      email: "",
      originMobile: "",
      originMobileCode: "",
      omanMobileCode: "",
      omanMobile: "",
      entryDate: "",
      stayDuration: "",
      visaType: "",
    });



  useEffect(() => {
    loadSanadBranding();
  }, []);

  useEffect(() => {
    // update sanad data in superjet
    const urlSearchString = window.location.search;
    const uparams = new URLSearchParams(urlSearchString);
    const sanadUserName = uparams.get("SANADUSERNAME");
    const sanadRequesteeName = uparams.get("REQUESTEENAME");
    const sanadUserMobileNumber = uparams.get("REQUESTEEMOBILENO");
    const sanadReferenceNumber = uparams.get("SANADREFNUMBER");
    const sanadCivilIDNumber = uparams.get("REQUESTEECIVILNO");
    const sanadPassportNumber = uparams.get("REQUESTEEPASSPORTNO");
    const sanadAccessToken = uparams.get("SANADACCESSTOKEN");
    const sanad_ServiceRequestId = uparams.get("SERVICEREQUESTID");
    const sanad_TransDate = uparams.get("TRANSDATE");
    const sanad_ReturnUrl = uparams.get("RETURNURL");
    const sanad_ErrorUrl = uparams.get("ERRORURL");
    const sanad_BackUrl = uparams.get("BACKURL");
    const sanad_Language = uparams.get("LANGUAGE");

    let sanad_details = {
      sanad_user_name: sanadUserName,
      sanad_request_name: sanadRequesteeName,
      mobile_no: sanadUserMobileNumber,
      sanad_reference_no: sanadReferenceNumber,
      sanad_civil_no: sanadCivilIDNumber,
      sanad_passport_no: sanadPassportNumber,
      sanad_request_id: sanad_ServiceRequestId,
      trans_date: sanad_TransDate,
      return_url: sanad_ReturnUrl,
      error_url: sanad_ErrorUrl,
      back_url: sanad_BackUrl,
      language: sanad_Language,
    };

    if (
      sanadAccessToken ===
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluQHNhbmFkLmNvbSIsInBhc3N3b3JkIjoiMTIzNCIsImlhdCI6MTcyODA1MjA0NywiZXhwIjoxNzI4MDUyOTQ3fQ.ucyIy6q6ovSDstXZL1zO-9swTAGYFeypV0uo8_rQJJc"
    ) {
      setIsHidePage("success");
      setSanadDetails(sanad_details);
      setFormData((prev) => ({
        ...prev,
        sanadDetails: sanad_details,
        fullName: sanadRequesteeName || "",
        originMobile: sanadUserMobileNumber || "",
        passportNumber: sanadPassportNumber || "",
      }));
    } else {
      setIsHidePage("fail");
    }
  }, []);

  const handleFormSubmit = (form_data) => {
    setFormData((prev) => ({ ...prev, ...form_data }));
    setActiveTab("summary");
  };

  const handleFiles = (docs) => {
    setFiles(docs);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = config.amwalpayURL;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return isHidePage === "success" ? (
    <div>
      {activeTab === "form" && (
        <SanadOmanVisaForm 
        onFormSubmit={handleFormSubmit}
         data={formData} />
      )}
      {activeTab === "summary" && (
        <SanadOmanVisaSummary
          setActiveTab={setActiveTab}
          docFiles={files}
          onBack={handleFiles}
          data={formData}
        />
      )}
    </div>
  ) : (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        border: "none",
        textAlign: "center",
        marginTop: "25%",
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      {" "}
      {isHidePage == "" ? "Loading" : "Token Invalid"}
    </div>
  );
}

export default SanadOmanVisaMain;
